import {React} from "react";
import Header from './Header';
import {CircularProgress,Container} from '@mui/material';
import './landingPage.css';
import './Header.css';
import DashBoard from "./DashBoard";
import {SentimentDissatisfied } from "@mui/icons-material";
import GenrePanel from './GenrePanel'


const LandingPage =({videoList,loading,handleSearch,handleGenre,handleAge,handleDropDown})=>
{
//const navigate=useNavigate();

return (
<>
<Header handleSearch={handleSearch}></Header>
<GenrePanel handleGenre={handleGenre} handleAge={handleAge} handleDropDown={handleDropDown}> </GenrePanel>
<br></br>


 {/* <Container maxWidth="sm" sx={{alignItems:'center'}}>

        <Stack direction="row" container spacing={2} sx={{flexWrap:'wrap'}}>
        <Chip label="All Genre" color="secondary" onClick={handleGenreChip} className='genre-btn'/>
        <Chip label="Education" variant="outlined" onClick={handleGenreChip} className='genre-btn' />
        <Chip label="Sports" variant="outlined" onClick={handleGenreChip} className='genre-btn'/>
        <Chip label="Comedy" variant="outlined" onClick={handleGenreChip} className='genre-btn' />
        <Chip label="LifeStyle" variant="outlined" onClick={handleGenreChip} className='genre-btn' />
        
        <select name="sort" id="sort" onChange={handleChange} className='sort-select'>
        <option value="Release Date" id="release-date-option" defaultValue> Release Date</option>
        <option value="View Count" id="view-count-option">View Count</option>
        </select>
        
        </Stack>
        
        
        <br></br>
        <Stack direction="row" container spacing={2} sx={{flexWrap:'wrap'}}>
        <Chip label="Any Age Group" color="secondary" onClick={handleGenreChip} className='content-rating-btn'/>
        <Chip label="7+" variant="outlined" onClick={handleGenreChip} className='content-rating-btn'/>
        <Chip label="12+" variant="outlined" onClick={handleGenreChip} className='content-rating-btn'/>
        <Chip label="16+" variant="outlined" onClick={handleGenreChip} className='content-rating-btn'/>
        <Chip label="18+" variant="outlined" onClick={handleGenreChip} className='content-rating-btn'/>
        </Stack>
        <br></br>
       
        
  </Container> */}
  
  
  <br></br>
  <br></br>
  
  <Container maxWidth='lg'>
  { loading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column",color:"white" }}>
            <CircularProgress sx={{color:'#FFFFFF'}} />
            <h1>Loading Videos</h1>
          </div>
  
        ) : 
          videoList.length===0? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column",color:"white" }} >
              <SentimentDissatisfied />
              <h1>No Videos Found</h1>
            </div>
          ):
          (
            <DashBoard videoList={videoList}/>
            )
          }
  
  </Container>
 </>
)
}

export default LandingPage;

